import script from "./affix.vue?vue&type=script&setup=true&lang=ts"
export * from "./affix.vue?vue&type=script&setup=true&lang=ts"

import "./affix.vue?vue&type=style&index=0&id=722ab14d&scoped=true&lang=less"

import exportComponent from "/root/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-722ab14d"]])

export default __exports__